import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  
  name: 'filter',
  pure: false,
})
@Injectable()
export class FilterPipe implements PipeTransform {
  /**
   * @param items object from array
   * @param term term's search
   * @param excludes array of strings which will ignored during search
   */
  transform(items: any, term: string, prop: string, filterMetadata: any): any {
    if (!term || !items) return items;
    filterMetadata.count = 0;
    return FilterPipe.filter(items, term, prop, filterMetadata);
  }

  /**
   *
   * @param items List of items to filter
   * @param term  a string term to compare with every property of the list
   * @param excludes List of keys which will be ignored during search
   *
   */
  static filter(
    items: Array<{ [key: string]: any }>,
    term: string,
    prop: string,
    filterMetadata: any
  ): Array<{ [key: string]: any }> {
    const toCompare = term.toLowerCase();
    function checkInside(item: any, _term: string) {
      if (
        typeof item === 'string' &&
        item.toString().toLowerCase().includes(toCompare)
      ) {
        return true;
      }

      if (
        item[prop].toString().toLowerCase().includes(toCompare)
      ) {
        filterMetadata.count = 1;
        return true;
      }

      return false;
    }

    return items.filter(function (item) {
      return checkInside(item, term);
    });
  }
}